/**
 * A small dialog that asks for a name (an inventor naming their construct). The server validates
 * it; this only trims it and keeps it within `max` characters.
 */

export interface NameDialogOptions {
  title: string;
  hint: string;
  value: string;
  max: number;
  onSave(name: string): void;
}

function esc(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);
}

export function openNameDialog(opts: NameDialogOptions): void {
  document.getElementById('name-modal')?.remove();
  const root = document.createElement('div');
  root.id = 'name-modal';
  root.innerHTML = `
    <form class="token-box name-box" role="dialog" aria-label="${esc(opts.title)}">
      <h1>${esc(opts.title)}</h1>
      <p class="muted">${esc(opts.hint)}</p>
      <input type="text" class="name-input" maxlength="${opts.max}" value="${esc(opts.value)}" autocomplete="off" spellcheck="false">
      <div class="modal-actions">
        <span class="spacer"></span>
        <button type="button" class="name-cancel">Cancel</button>
        <button type="submit" class="primary name-save">Save Name</button>
      </div>
    </form>`;
  document.body.appendChild(root);
  const input = root.querySelector<HTMLInputElement>('.name-input')!;
  const save = root.querySelector<HTMLButtonElement>('.name-save')!;
  const close = () => {
    root.remove();
    window.removeEventListener('keydown', onKey, true);
  };
  const onKey = (e: KeyboardEvent) => {
    // Typing a name mustn't move the character or fire hotkeys.
    e.stopPropagation();
    if (e.key === 'Escape') close();
  };
  window.addEventListener('keydown', onKey, true);
  const sync = () => {
    save.disabled = !input.value.trim();
  };
  input.addEventListener('input', sync);
  root.querySelector('.name-cancel')!.addEventListener('click', close);
  root.addEventListener('pointerdown', (e) => {
    if (e.target === root) close();
  });
  root.querySelector('form')!.addEventListener('submit', (e) => {
    e.preventDefault();
    const name = input.value.replace(/\s+/g, ' ').trim();
    if (!name) return;
    opts.onSave(name);
    close();
  });
  sync();
  input.focus();
  input.select();
}
